import { IOptions } from "sanitize-html"

/**
 * Options for $sanitize, applied to every v-html binding that renders text a user typed
 * into a rich text field.
 *
 * allowedTags is deliberately not set, so sanitize-html's own default list applies. That
 * list excludes img and iframe, so images and video embeds are stripped on display.
 */

// Quill's own classes, which have to survive sanitising or rich text loses its formatting.
const QUILL_CLASSES = [
	"ql-indent-1", "ql-indent-2", "ql-indent-3", "ql-indent-4", "ql-indent-5",
	"ql-indent-6", "ql-indent-7", "ql-indent-8", "ql-indent-9",
	"ql-video", "ql-align-center", "ql-align-justify", "ql-align-right",
	"ql-font-serif", "ql-font-monospace",
	"ql-size-small", "ql-size-large", "ql-size-huge", "ql-direction-rtl",
	"ql-blank",
	"ql-bg-red", "ql-bg-orange", "ql-bg-yellow", "ql-bg-green", "ql-bg-blue", "ql-bg-purple",
	"ql-color-white", "ql-color-red", "ql-color-orange", "ql-color-yellow",
	"ql-color-green", "ql-color-blue", "ql-color-purple"
]

const sanitizeOptions: IOptions = {
	allowedAttributes: {
		"*": ["class"],
		a: ["href", "rel", "target"]
	},
	allowedClasses: {
		"*": QUILL_CLASSES
	}
}

export { QUILL_CLASSES }
export default sanitizeOptions
